<div @fadeIn class="abstract-container">
    <ion-icon name="close-outline" (click)="closeAbstractLogin()"></ion-icon>
    <iframe [ngStyle]="{ opacity: loading ? 0 : 1 }" src="" id="abstractIframe"></iframe>
    <ion-spinner @fadeIn name="crescent" *ngIf="loading"></ion-spinner>
</div>